import React from 'react';
import { Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

export default function RegionalServicesButton({ onClick, count, edit }) {
  const buttonText =
    count && count > 0
      ? `Manage Regional Services (${count})`
      : 'Add Regional Services';

  return (
    <Button
      variant='outlined'
      startIcon={<EditIcon />}
      onClick={onClick}
      disabled={edit}
    >
      {buttonText}
    </Button>
  );
}

